const reportEn = {
    farmReport: require('../../lang/en/report/FarmReport').default,
    cropPlaningReport: require('../../lang/en/report/CropPlaningReport').default,
    constructionReport: require('../../lang/en/report/ConstructionReport').default,
};

export default reportEn;